module.exports = __webpack_public_path__ + "static/media/location.d837a73c.svg";